var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enabled)?_c('div',{staticClass:"quantity-dropdown-wrapper"},[_c('v-select',{key:_vm.dropdownKey,staticClass:"quantity-dropdown",attrs:{"value":_vm.currentValue,"items":_vm.dropdownItems,"outlined":"","hide-details":"","item-text":"text","item-value":"value","menu-props":{
      top: true,
      offsetY: true,
      contentClass: 'quantity-dropdown-menu',
      maxHeight: 400,
      minWidth: 200
    }},on:{"change":_vm.onDropdownChange}}),_c('custom-quantity-dialog',{attrs:{"is-open":_vm.customDialogOpen,"current-quantity":_vm.selectedQuantity},on:{"custom-quantity-selected":_vm.onCustomQuantitySelected,"close":_vm.onCustomDialogClose}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }